import React, { Fragment, useEffect, useState } from 'react';
import cx from "classnames";
import Select, { components } from "react-select";
import { useForm, Controller } from "react-hook-form";
//import { Editor } from 'react-draft-wysiwyg';
// import {
//     ContentState,
//     convertToRaw,
//     EditorState,
//     convertFromHTML,
// } from 'draft-js';
import CommonHeaderContent from '../../../Common/CommonHeaderContent';
import requestApi from '../../../services/requestApi.service';
import { addTableBorder, CustomOption, getSystemActionContent, isValidEmail, isValidMobileNumber, parseExtraRecipients, parseSendActionExpression, populateRecipientOptionList, replaceHtmlToString, replaceStringTohtml } from '../../../Common/Appcommon';
import draftToHtml from 'draftjs-to-html';
import { useRef } from 'react';
import { faFloppyDisk } from '@fortawesome/free-regular-svg-icons';
import CKEditorComponent from '../../../Common/CKEditor/CKEditorComponent';

function SendAction(props) {
    let { onSelectChange, closeModal, screenDetail, channel, titleTxt, systemActionSubmit, typeofaction, actions, actionIndex, enableActionDelay } = props;
    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, setError } = useForm();
    const [showLoader, setShowLoader] = useState(false);
    let [formData, setFormData] = useState({});
    let [recipientOptions, setRecipientOptions] = useState([]);
    const [templateOptions, setTemplateOptions] = useState([]);
    const [templateDetails, setTemplateDetails] = useState({});
    let templateIdMapper = [];
    let [selectedTemplate, setSelectedTemplate] = useState([]);
    //let [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [emailTemplateContent, setEmailTemplateContent] = useState("");
    const [channelRecipientOptions, setChannelRecipientOptions] = useState([]);
    let [message, setMessage] = useState("");
    const buttonClickRef = useRef();
    const editorRef = useRef();
    useEffect(() => {
        (async () => {
            await getAllTemplates();
            await populateOptionList();
        })();
        return () => {
            // this now gets called when the component unmounts
        };

    }, []);

    const populateOptionList = async () => {
        let fieldDetails = screenDetail.length > 0 ? screenDetail[1] : [];
        let optionList = await populateRecipientOptionList(fieldDetails, channel);

        setChannelRecipientOptions(optionList);
        if (actions[actionIndex] !== undefined) {
            let actionData = actions[actionIndex];
            await prepareActionEditor(actionData, optionList);
        }
    }

    const getAllTemplates = async () => {
        let { screenDetail } = props;
        let formDetail = screenDetail[0];
        let modulename = formDetail[0];
        let formname = formDetail[1];
        let params = {
            "ENTITY": channel === "email" ? "EMAILTEMPLATE_ENTITYNAME" : "SMSTEMPLATE_ENTITYNAME",
            "OPERATION": "Get_All_Template",
            "FORMNAME": formname,
            "MODULENAME": modulename,
            "channel": channel
        }

        let res = await requestApi.processServerRequest(params, "WebV2", "post");
        if (res.issuccess) {
            let templates = res.data[0];
            let templateOptionList = [];
            let allTemplateDetails = [];
            let optionLink = "#/settings/crmTemplates/emailtemplates";
            if(channel === "sms"){
                optionLink = "#/settings/crmTemplates/smstemplates";
            }
            templateOptionList.push({ value: 'create_template', label: 'Create Template', link: optionLink });
            templates.map((template) => {
                templateOptionList.push({ value: template[1], label: template[2] });
                allTemplateDetails[template[1]] = template;
            });
            templateIdMapper = allTemplateDetails;
            setTemplateOptions(templateOptionList);
            setTemplateDetails(allTemplateDetails);
        }
    }

    const prepareActionEditor = async (actionData, recpOptions) => {
        let { templatename, systemActionStr, action_name } = actionData;
        formData = actionData;
        let { subject, toRecp, cc, bodyContent } = await parseSendActionExpression(systemActionStr);
        let template = templateIdMapper[templatename];
        if (template !== undefined && template.length > 0) {
            selectedTemplate = { value: template[1], label: template[2] };
            setSelectedTemplate(selectedTemplate);
            if (channel === "sms" && template[5] && template[5] !== "") {
                setMessage(template[5]);
            }
        }
       // let contentBlocks = convertFromHTML(bodyContent);
        //let tempeditorState = htmlToDraftBlocks(templateContent);
       // let tempeditorState = EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks.contentBlocks, contentBlocks.entityMap));
       // setEditorState(tempeditorState);
        setEmailTemplateContent(bodyContent);
        formData["subject"] = subject;
        let { recipientOptions, extraRecipients } = await parseExtraRecipients(toRecp, recpOptions, channel);
        /*let extraRecipients = "";
        toRecp.map((item) => {
            let isOptionMapped = false;
            for(let co = 0; co < recpOptions.length; co++){
                let option = recpOptions[co];
                if(option.value === item){
                    isOptionMapped = true;
                    recipientOptions.push(option);
                    break;
                }
            }    
            if(!isOptionMapped && channel !== "email"){
                extraRecipients += item+",";
            }
        });
        if(extraRecipients !== ""){
            extraRecipients = removeLastChar(extraRecipients);
        }*/
        formData["extra_recipients"] = channel === "email" ? cc : extraRecipients;
        formData["action_name"] = action_name;
        setFormData(formData);

        setRecipientOptions(recipientOptions);
    }

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        formData[name] = value;
        setFormData(formData);
    }

    const onDropDownChange = async (selectedValue, objName) => {
        if (objName === "recipents") {
            setRecipientOptions(selectedValue);
        } else if (objName === "templates") {
            setSelectedTemplate(selectedValue);
            let templateId = selectedValue.value;
            let template = templateDetails[templateId];
            if (template.length > 0) {
                let templateContent = template[5];
                let subject = template[6];
                if (channel === "email") {
                    /*let contentBlocks = convertFromHTML(templateContent);
                    let html = replaceStringTohtml(templateContent);
                    //let tempeditorState = htmlToDraftBlocks(templateContent);
                    let tempeditorState = EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks.contentBlocks, contentBlocks.entityMap));
                    setEditorState(tempeditorState);*/
                    setEmailTemplateContent(templateContent);
                    formData["subject"] = subject;
                    setFormData(formData);
                } else if (channel === "sms") {
                    setMessage(templateContent);
                }
            }
        }
    }

    const getFormChannelField = (channel) => {
        let fieldDetails = screenDetail.length > 0 ? screenDetail[1] : [];
        for (let fi = 0; fi < fieldDetails.length; fi++) {
            let fd = fieldDetails[fi];
            let fieldName = fd[2];
            let fieldLabel = fd[3];
            let fieldType = fd[4];
            if (fieldType === channel) {
                return fieldLabel;
            }
        }
    }

    const saveSendAction = async () => {
        let isValidRecipient = validateRecipient();
        if (!isValidRecipient) return;
        let { subject, action_name, extra_recipients } = formData;
        let templateId = selectedTemplate.value;
        /*         let msgContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
                if (channel !== "email") {
                    msgContent = replaceHtmlToString(msgContent);
                }
        
                msgContent = msgContent.trimEnd(); */
        let msgContent = channel === "sms" ? message : emailTemplateContent;
        msgContent = addTableBorder(msgContent)
        if(channel === "sms"){
            subject = "";
        }
        let actionParams = formData;
        let systemActionStr = await getSystemActionContent(recipientOptions, extra_recipients, subject, msgContent, channel);
        actionParams['templatename'] = templateId;
        actionParams['systemActionStr'] = systemActionStr;
        actionParams["typeofaction"] = typeofaction;
        console.log(actionParams);
        systemActionSubmit(actionParams, actionIndex);
        enableActionDelay();
        closeModal();
    }

    // const onModifyEditor = (editorState) => {
    //     setEditorState(editorState);
    // }

    const onCKEditorChange = async (ocontent, editor) => {
        let content = editor.getData();
        setEmailTemplateContent(content);
    }

    const getChannelHeaderTitle = () => {
        let title = "";
        if (channel === "email") {
            title = "Email Information";
        } else if (channel === "sms") {
            title = "SMS Information";
        } else if (channel === "whatsapp") {
            title = "Whatsapp Information";
        }
        return title;
    }

    let fieldDetails = screenDetail.length > 0 ? screenDetail[1] : [];
    let ownerField = [];
    for (let fi = 0; fi < fieldDetails.length; fi++) {
        let fd = fieldDetails[fi];
        let fieldType = fd[4];
        if (fieldType === "entity_group") {
            ownerField = fd;
            break;
        }
    }

    const triggerSubmit = () => {
        buttonClickRef.current.click();
    }
    const mentionItems = [
        { id: '@john', name: 'John Doe' },
        { id: '@jane', name: 'Jane Doe' },
        { id: '@doe', name: 'Doe' }
    ];

    const validateRecipient = () => {
        let recipients = formData.extra_recipients;
        let errorMsg = "";
        let isValid = true;
        if (recipients !== "" && recipients !== undefined) {
            let tmpMsg = "";
            let recipientArr = recipients.split(",");
            recipientArr.map((recipient) => {
                if (channel === "email") {
                    let isValid = isValidEmail(recipient);
                    if (!isValid) {
                        tmpMsg = tmpMsg + recipient + " is not valid";
                    }
                } else if (channel === "sms") {
                    let isValid = isValidMobileNumber(recipient);
                    if (!isValid) {
                        tmpMsg = tmpMsg + recipient + " is not valid";
                    }
                }
            });
            errorMsg = tmpMsg;
        }
        if (errorMsg !== "") {
            isValid = false;
            setError("extra_recipients", {
                type: "manual",
                message: errorMsg
            });
        }
        return isValid;

    }
    
    return <Fragment>
        <CommonHeaderContent
            isModal={true}
            closeModal={closeModal}
            headerTitle={titleTxt}
            buttonAction={triggerSubmit}
            buttonTxt={"Save & Close"}
            buttonIcon={faFloppyDisk}
            isClassNeeded={false}
            mainContent={
                <Fragment>
                    <form id="action-form" name="task-action">
                        <div className='action-editor-container'>
                            <div className='editor-header'>
                                <span className='headerSpan'>{getChannelHeaderTitle()}</span>
                            </div>
                            <div className='editor-body'>
                                <div className='form-conatiner'>
                                    <div className='input-section'>
                                        <label className={'workflow-lbl form-label'} htmlFor="action_name">Name</label>
                                        <Controller
                                            name="action_name"
                                            control={control}
                                            rules={{ required: formData.action_name === undefined ? "Please provide Name" : "" }}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        name="action_name"
                                                        id="action_name"
                                                        value={formData.action_name}
                                                        autoComplete={"off"}
                                                        onChange={(e) => {
                                                            onInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        className={`form-control ${errors.action_name ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.action_name && <em className={`error invalid-feedback`}>{errors.action_name.message}</em>}
                                    </div>
                                    <div className='input-section '>
                                        <label className={'workflow-lbl form-label'} htmlFor="recipents">Recipients</label>
                                        <div className={``}>
                                            <Controller
                                                name="recipents"
                                                control={control}
                                                rules={{ required: Object.keys(recipientOptions).length === 0 ? "Choose" : false }}
                                                render={({ field }) => {
                                                    return (
                                                        <Select
                                                            {...field}
                                                            isMulti
                                                            placeholder={'---Choose One---'}
                                                            menuPlacement={"auto"}
                                                            menuPosition={'fixed'}
                                                            name={"recipents"}
                                                            id={"recipents"}
                                                            className={`basic-multi-select ${errors.recipents ? 'is-invalid' : ''}`}
                                                            classNamePrefix="wa-select"
                                                            value={recipientOptions}
                                                            onChange={e => {
                                                                onDropDownChange(e, "recipents");
                                                                field.onChange(e);
                                                            }}
                                                            options={channelRecipientOptions}
                                                        />
                                                    );
                                                }}
                                            />
                                            {errors.recipents && <em className={`error invalid-feedback`}>{errors.recipents.message}</em>}

                                        </div>
                                    </div>
                                    <div className='input-section'>
                                        <label className={'workflow-lbl form-label'} htmlFor="extra_recipients">Additional Recipients</label>
                                        <Controller
                                            name="extra_recipients"
                                            control={control}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        name="extra_recipients"
                                                        id="extra_recipients"
                                                        value={formData.extra_recipients}
                                                        autoComplete={"off"}
                                                        onChange={(e) => {
                                                            onInputChange(e);
                                                            field.onChange(e);
                                                        }}
                                                        placeholder='Use commas to separate recipients without a space '
                                                        className={`form-control ${errors.extra_recipients ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.extra_recipients && <em className={`error invalid-feedback`}>{errors.extra_recipients.message}</em>}
                                    </div>
                                    <div className='input-section'>
                                        <label className={'workflow-lbl form-label'} htmlFor="templates">Templates</label>
                                        <div className=''>
                                            <Controller
                                                name="templates"
                                                control={control}
                                                rules={{ required: Object.keys(selectedTemplate).length === 0 ? "Choose" : false }}
                                                render={({ field }) => {
                                                    return (
                                                        <Select
                                                            {...field}
                                                            placeholder={'---Choose One---'}
                                                            menuPlacement={"auto"}
                                                            menuPosition={'fixed'}
                                                            name={"templates"}
                                                            id={"templates"}
                                                            className={`basic-multi-select ${errors.templates ? 'is-invalid' : ''}`}
                                                            classNamePrefix="wa-select"
                                                            value={selectedTemplate}
                                                            onChange={e => {
                                                                onDropDownChange(e, "templates");
                                                                field.onChange(e);
                                                            }}
                                                            options={templateOptions}
                                                            components={{ Option: CustomOption }}

                                                        />
                                                    );
                                                }}
                                            />
                                        </div>
                                        {errors.templates && <em className={`error invalid-feedback`}>{errors.templates.message}</em>}
                                    </div>
                                    {Object.keys(selectedTemplate).length > 0 && selectedTemplate.value !== "create_template" &&
                                        <div>
                                            {channel === "email" &&
                                                <div className='input-section'>
                                                    <label className={'workflow-lbl form-label'} htmlFor="subject">Subject</label>
                                                    <Controller
                                                        name="subject"
                                                        control={control}
                                                        rules={{ required: formData.subject === "undefined" || formData.subject === "" ? "Please provide Subject" : "" }}
                                                        render={({ field }) => {
                                                            return (
                                                                <input
                                                                    {...field}
                                                                    type="text"
                                                                    name="subject"
                                                                    id="subject"
                                                                    value={formData.subject}
                                                                    autoComplete={"off"}
                                                                    onChange={(e) => {
                                                                        onInputChange(e);
                                                                        field.onChange(e);
                                                                    }}
                                                                    disabled
                                                                    className={`form-control ${errors.subject ? 'is-invalid' : ''}`}
                                                                />
                                                            );
                                                        }}
                                                    />
                                                    {errors.subject && <em className={`error invalid-feedback`}>{errors.subject.message}</em>}
                                                </div>
                                            }
                                            <div className='input-section'>
                                                <label className={'workflow-lbl form-label'} htmlFor="body_label">{channel === "email" ? "Body" : "Message"}</label>
                                                {channel === "email" &&
                                                    <div className='template-editor'>
                                                        {/*<Editor
                                                            editorState={editorState}
                                                            editorClassName={cx(`email-template-editor`, {

                                                            })}
                                                            wrapperClassName={cx(`email-template-editor-wrapper`, {

                                                            })}
                                                            toolbarHidden={channel !== "email"}
                                                            toolbar={toolbar}
                                                            readOnly={channel == "sms"}
                                                        onEditorStateChange={onModifyEditor} />*/}
                                                        <CKEditorComponent
                                                            isMentionsNeeded={false}
                                                            content={emailTemplateContent}
                                                            isNew={false}
                                                            mentionItems={[]}
                                                            onEditorChange={onCKEditorChange}
                                                        />
                                                    </div>
                                                }
                                                {channel === "sms" &&
                                                    <div class="body-content-txt">
                                                        <span class="content-preview">
                                                            <span class="" dir="auto">
                                                                {message}
                                                            </span>
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                            <div className='editor-footer modal-footer hide'>
                                <a onClick={(e) => closeModal(e)} class="btn btn-outline-success">Cancel</a>
                                <button ref={buttonClickRef} onClick={handleActionFormSubmit(saveSendAction)} class="ml-1 btn btn-outline-success">Save</button>
                            </div>
                        </div>
                    </form>
                </Fragment>
            } />
    </Fragment>
}

export default SendAction;